import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DataTableSortOrder } from "./DataTable";
import { ArrowDownward } from "@material-ui/icons";
import { TableCell } from "@material-ui/core";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        cursor: "pointer"
    },
    inner: {
        display: "flex",
        alignItems: "center"
    },
    label: {
        marginRight: theme.spacing(1)
    },
    icon: {
        visibility: function (props) {
            return props.dir === DataTableSortOrder.None ? "hidden" : "visible";
        },
        transform: function (props) {
            return props.dir === DataTableSortOrder.Asc ? "rotate(180deg)" : "none";
        },
        transition: "transform .3s"
    }
}); });
export var SortableColumnHeader = function (props) {
    var classes = useStyles(props);
    return (React.createElement(TableCell, { onClick: props.onClick, className: classes.root },
        React.createElement("div", { className: classes.inner },
            React.createElement("div", { className: classes.label }, props.children),
            React.createElement(ArrowDownward, { className: classes.icon }))));
};
//# sourceMappingURL=SortableColumnHeader.js.map